<script>
    import ReservationFilters from './ReservationFilters'
    import {Form} from '../../../helpers/Form/Form'

    export default {
        name: "Bookings",
        props: ['reservationSource', 'requestsCount', 'company'],
        components: {ReservationFilters},
        data () {
            return {
                orderList: [
                    { id: 'more', name: 'Ordina per più recenti' },
                    { id: 'less', name: 'Ordina per meno recenti' }
                ],
                filterList: [
                    { id: 'swimming', name: 'Corso di Nuoto 15-20 anni' },
                    { id: 'lodging', name: 'Corso di Canotaggio 16-24 anni' }
                ],
                selected: {},
                reservations: [],
                orderBy: null,
                currentFilter: null,
                form: new Form({
                    company_id: this.company,
                    reservation_id: null,
                    reservation_status: null,
                    courses: [],
                    date: null,
                    user: null,
                    is_member: false,
                    not_member: false                       
                })
            }
        },
        computed: {
            receviedReservations() {
                let reservations = this.reservations.filter(i => !i.is_expired)
                return reservations.length
            }
        },
        mounted() {
            this.fetchReservations()

            this.$bus.$on('update-reservation', this.updateReservations)      

            $("#reservation-filters").modal({
                show: false,
                backdrop: 'static',
                escape: false
            })
        },
        methods: {
            onRefreshReservations(filters) {
                for (let prop in filters) {
                    if (this.form.hasOwnProperty(prop)) {
                        this.$set(this.form, prop, filters[prop])
                    }
                }

                this.fetchReservations()
            },
            fetchReservations() {
                this.form
                    .get(route('companies.reservations.index'))
                    .then(({reservations}) => {
                        this.$set(this, 'reservations', reservations)
                    })
            },
            isExpired(reservation) {
                if (moment(reservation.datetime).isAfter(moment())) {
                    return false;
                }
                return true;
            },
            onSubmitAcceptReservation(reservation) {
                this.form.setData('reservation_id', reservation.id)
                this.form.setData('reservation_status', true)

                this.form
                    .submit('post', this.reservationSource)
                    .then(({reservation}) => {
                        window.alerts.success('Prenotazione aggiornata correttamente');

                        this.updateReservations({reservation})
                    })
            },
            toggleOrder(filter) {
                if (!_.isEmpty(this.currentFilter)) {
                    if (this.currentFilter != filter) {
                        return 'asc'
                    }
                }

                if (_.isEmpty(this.orderBy)) {
                    return 'asc'
                }

                if (this.orderBy == 'asc') {
                    return 'desc'
                }

                return 'asc'
            },
            applyReservationFilter(filter, value = null) {
                let orderedCollection = []
                this.orderBy = this.toggleOrder(filter)
                this.currentFilter = filter

                if (filter == 'course') {
                    orderedCollection = _.orderBy(this.reservations, i => {
                        return i.course.name
                    }, [this.orderBy])
                } else if (filter == 'status') {
                    let orderBy = value ? 'desc' : 'asc'
                    orderedCollection = _.orderBy(this.reservations, [filter], [orderBy]);
                } else if (filter == 'is_membership') {
                    let orderBy = value ? 'desc' : 'asc'
                    orderedCollection = _.orderBy(this.reservations, [filter], [orderBy]);
                } else {
                    orderedCollection = _.orderBy(this.reservations, [filter], [this.orderBy]);
                }

                this.$set(this, 'reservations', orderedCollection)
            },
            hasEmptyStatus({status}) {
                return !_.isBoolean(status)
            },
            updateReservations({reservation}) {
                let reservationIdx = _.findIndex(this.reservations, i => i.id == reservation.id)
                if (reservationIdx >= 0) {
                    this.$set(this.reservations, reservationIdx, reservation)
                }
            },
            setReservationResponse(reservation, status = false) {
                this.$bus.$emit('update-reservation-response', {
                    reservation,
                    status
                })
            },
            onReservationContact(reservation) {
                this.$bus.$emit('update-reservation-contact', {
                    reservation
                })
            },
            formatDate(date) {
                return moment(date).format('DD/MM/YYYY')
            },
            formatTime(date) {
                return moment(date).format('LT')
            },
            calculateAge(birthday) {
                var from = moment(birthday).fromNow();
                return from.match(/\d+/)[0];
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/Reservations.vue